import React from 'react';
import { editScreeningSubjectName } from '../../../utils/screeningName';
import '../css/ScreeningNameNotice.css';

export default function ScreeningNameNotice({ subjects, readOnly }) {
  return subjects.map(subject => (
    <div className="screeningNameCard" key={subject.key}>
      <div className="screeningNameCardHeader">
        <div><strong>{subject.name}</strong><div className="text-muted small">{subject.roles.join(' · ')}</div></div>
        <span className="screeningNameBadge">Full name required</span>
      </div>
      <div className="screeningNameMessage" role="status">
        <span>Please enter the person full name prior to screen the individual</span>
        {!readOnly && <button type="button" onClick={() => editScreeningSubjectName(subject)}>Edit name</button>}
      </div>
    </div>
  ));
}
